import React, { createContext, useState, useEffect, useContext } from 'react';
import commonApi from '../utils/api';
import { CommonContext } from './CommonContext';
import { useLocation } from 'react-router-dom';

export const AssetContext = createContext();

export function AssetContextProvider({ children }) {
    const { user } = useContext(CommonContext);
    const location = useLocation();

    const [addModal, setAddModal] = useState(false);
    const [allData, setAllData] = useState([]);
    const [allAsset, setAllAsset] = useState([]);
    const [viewData, setViewData] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [firstLoading, setFirstLoading] = useState(false);
    const [openAlert, setOpenAlert] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [alertMesaage, setAlertMesaage] = useState('');
    const [severity, setSeverity] = useState('');

    const onCloseAlert = () => {
        setOpenAlert(false);
        setAlertMesaage('');
        setSeverity('')
    };

    const handleAddModal = () => {
        setAddModal(true);
    };

    const handleCloseModal = () => {
        setViewData('')
        setIsEdit(false);
        setAddModal(false);
    };

    const onLoadApi = () => {
        let postReq = {};
        if (user?.user_type === "Merchant") {
            postReq = { merchant_id: user?.id }
        } else {
            postReq = { admin_id: user?.id }
        }
        if(location?.state) {
            postReq.user_id = location?.state?.id;
        }
        setFirstLoading(false);
        setAllData([]);
        setAllAsset([]);
        commonApi.post('users/assets/list', postReq)
            .then((response) => {
                setFirstLoading(true);
                if (response?.data?.data) {
                    setAllAsset(response?.data?.data);
                    setAllData(response?.data?.data);
                }
            })
            .catch((error) => {
                setFirstLoading(true);
                console.error('Error fetching data:', error);
            });
    };

    useEffect(() => {
        onLoadApi();
    }, []);

    // You can provide any values or functions you want to make available to consumers here
    const contextValue = {
        isEdit,
        onCloseAlert,
        severity,
        alertMesaage,
        openAlert,
        onLoadApi,
        isLoading,
        firstLoading,
        viewData,
        allAsset,
        allData,
        handleAddModal,
        handleCloseModal,
        setAddModal,
        addModal,
        setAllData,
        setAllAsset,
        setViewData,
        setFirstLoading,
        setIsLoading,
        setSeverity,
        setAlertMesaage,
        setOpenAlert,
        setIsEdit,
    };

    // Render the provider with children
    return <AssetContext.Provider value={contextValue}>{children}</AssetContext.Provider>;
}
